export enum AppHookCodes {
  ACTOR_IDENTIFIED = "actor_identified",
  ADD_CATALOGUE_PRODUCT_COMPLETED = "add_catalogue_product_completed",
  ADD_CLIENT_ABANDONED = "add_client_abandoned",
  ADD_CLIENT_COMPLETED = "add_client_completed",
  ADD_TO_BASKET_SUCCESS = "add_to_basket_success",
  ADMIN_USER_LOGGED_IN = "admin_user_logged_in",
  CHECKOUT_STARTED = "checkout_started",
  CLIENT_REGISTERED = "client_registered",
  DEMO_DATA_SEEDED = "demo_data_seeded",
  ORDER_CONVERTED = "order_converted",
  ORDER_PAID = "order_paid"
}
